// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"974085d9","977":"efd442cd"}[chunkId] + ".chunk.js";
};